import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const SHeaderForm = styled.div`
  padding: 20px 24px;
`;

export const SFormInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const SFormInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
  
  .ant-form-item {
    width: 280px;
    margin: 0;
  }
`;

export const NoDataContainer = styled.div`
  margin: 180px auto;
  width: 306px;
  text-align: center;
`;

export const SNoResultText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${themeColors.character.primary85};
  margin-top: 10px;
`;
